var gdosWrapper = {
	config: {
		postal: "//public.api.gdos.salvationarmy.org/geocode/postal?",
		search: "//public.api.gdos.salvationarmy.org/search?",
		zip: undefined,
		latLong: [],
		gdosResults: {},
		servicesByLocation: [],
		locationByService: [],
		icon: '/templates/usa_nhq_symphony/static_resources/images/global/location-pin.png',
		resultsContainer: $('.gdosResults')
	},
	getLatLong: function(postalCode){
		return $.getJSON( '//public.api.gdos.salvationarmy.org/geocode/postal?', {
			isoCountry: "us",
			postalCode: postalCode
		}).then(function(data) {
			return data;
		});
	},
	getCenters: function(lat, long){
		return $.getJSON( '//public.api.gdos.salvationarmy.org/search?"', {
				isoCountry: "us",
				lat:lat,
				lng:long,
				distanceUnits:'MILES',
				limit:20
		}).then(function(data) {
			return data;
		});
	},
	parseResults: function(data){

		if(!gdosWrapper.validateData(data)){
			return;
		}

		var parsedResults = data;

		if(typeof data === "string"){
			parsedResults = JSON.parse(data)
		} 

		return parsedResults;

	},
	groupResults: function(data){
		
		if(!gdosWrapper.validateData(data)){
			return;
		}

		var centersBySvc = [];
		_(data).forEach(function(center) {
			if(center.services && center.services.length > 0){
				center.serviceCategory = [];
				_(center.services).forEach(function(svc) {
					var cntr = JSON.parse(JSON.stringify(center));
					if(svc.name === 'Drop Box') {
						cntr.serviceCategory = "Donation Drop Off Locations";
					} else {
						cntr.serviceCategory = svc.name;
					}
					centersBySvc.push(cntr);
				});
			} else {
				center.serviceCategory = ["Other Services"];
				centersBySvc.push(center);
			}
		});

		return _.groupBy(_.sortBy(centersBySvc, "serviceCategory"), "serviceCategory");
	},
	storeResults: function(data){

		if(!gdosWrapper.validateData(data)){
			return;
		}

		if(!window.localStorage) {
			return;
		}

		localStorage.setItem("gdosResults", data);

	},
	validateData: function(data){
		if(data === null || data === undefined || typeof data == 'undefined') {
			return false;
		}
			return true;
	},
	createMap: function(data, element){

		if(!gdosWrapper.validateData(data) || !gdosWrapper.validateData(element)){
			return;
		}

		var map = new GMaps({
			el: element,
			lat: data[0].location.latitude,
			lng: data[0].location.longitude,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true,
			draggable: false
		});

		_(data).forEach(function(center) {
			map.addMarker({
				lat: center.location.latitude,
				lng: center.location.longitude,
				title: center.name,
				click: function(e) {
					var icon = this.icon;
					_(map.markers).forEach(function(marker) {
					  marker.setIcon(icon);
					});
					e.setIcon(this.activeIcon);
					$('.gdosDetails').removeClass('isActive').empty().append(symphony.templates.gdosSingleResult(center)).addClass('isActive');
				},
				icon: {
					size: new google.maps.Size(24,39),
					url: gdosWrapper.config.icon
				},
				activeIcon: {
					size: new google.maps.Size(24,39),
					url: "//westernusa.salvationarmy.org/templates/usa_nhq_symphony/static_resources/images/global/location-pin-active.png"
				}
			});
		});
		map.refresh();
		map.fitZoom();
	}
};